<script>

import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";


export default {
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "پیشخوان",
    };
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col">
        <div class="h-100">

        </div>
        <!-- end .h-100-->
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>
